import { render, staticRenderFns } from "./TopView.vue?vue&type=template&id=4b928f79&scoped=true"
import script from "./TopView.vue?vue&type=script&lang=js"
export * from "./TopView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b928f79",
  null
  
)

export default component.exports